import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthGate } from "./components/auth/AuthGate";
import { SurfShell } from "./components/shell/SurfShell";
import { SurfJobQueueProvider } from "./hooks/useSurfJobQueue";
import { SurfEditorActivityProvider } from "./hooks/useSurfEditorActivity";
import { SurfLibraryProvider } from "./hooks/useSurfLibrary";
import { AccountPage } from "./pages/AccountPage";
import { DeckEditorPage } from "./pages/DeckEditorPage";
import { LibraryPage } from "./pages/LibraryPage";
import { SpeakerReaderPage } from "./pages/SpeakerReaderPage";
import { SpeakerReaderResume } from "./components/reader/SpeakerReaderResume";
import { RemoteControl } from "./components/present/RemoteControl";
import { WizardPage } from "./pages/WizardPage";
import { ErrorBoundary } from "./ui/ErrorBoundary";
import { ToastProvider } from "./ui/Toast";

function AuthedApp() {
  return (
    <SurfLibraryProvider>
      <SurfJobQueueProvider>
        <SurfEditorActivityProvider>
          <ErrorBoundary title="Errore Surf">
            <Routes>
              <Route element={<SurfShell />}>
                <Route
                  path="/"
                  element={
                    <SpeakerReaderResume>
                      <LibraryPage />
                    </SpeakerReaderResume>
                  }
                />
                <Route path="/account" element={<AccountPage />} />
              </Route>
              <Route path="/deck/:deckId/wizard" element={<WizardPage />} />
              <Route path="/deck/:deckId/speaker" element={<SpeakerReaderPage />} />
              <Route path="/deck/:deckId/remote" element={<RemoteControl />} />
              <Route path="/deck/:deckId" element={<DeckEditorPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </ErrorBoundary>
        </SurfEditorActivityProvider>
      </SurfJobQueueProvider>
    </SurfLibraryProvider>
  );
}

export default function App() {
  return (
    <ToastProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/*"
            element={
              <AuthGate>
                <AuthedApp />
              </AuthGate>
            }
          />
        </Routes>
      </BrowserRouter>
    </ToastProvider>
  );
}
